export function isPwaRuntimeEligible() {
  const explicit = import.meta.env.VITE_PWA_ENABLED;

  if (explicit === "false")
    return false;

  if (explicit !== "true" && import.meta.env.DEV)
    return false;

  if (import.meta.env.VITE_USE_MOCK_API === "true")
    return false;

  if (typeof window === "undefined" || !("serviceWorker" in navigator))
    return false;

  if (window.alkokhDesktop?.isElectron)
    return false;

  return window.isSecureContext;
}
